import bokalSourage from 'services/bokalSourage';

console.log(`ohm-landing version: ${ process.env.VERSION } (${ process.env.BRANCH })`);

export const DEV = process.env.NODE_ENV === 'development' || bokalSourage.get('DEV');
export const PROD = window.location.hostname === 'ohm.agency' || bokalSourage.get('PROD');
export const STANDALONE = !document.querySelector('#page-wrapper');
export const TEST = !!window.Cypress;

const { userAgent } = window.navigator;
export const BROWSER = userAgent.includes('Chrome') ? 'Chrome'
  : userAgent.includes('Safari') ? 'Safari'
  : userAgent.includes('Firefox') ? 'Firefox'
  : userAgent.includes('Trident') || userAgent.includes('MSI') ? 'IE'
  : null;

export const OS = userAgent.includes('iP') ? 'iOS'
  : userAgent.includes('Win') ? 'Win'
  : userAgent.includes('Mac') ? 'Mac'
  : null;

OS && document.documentElement.classList.add(`--${ OS.toLowerCase() }`);
BROWSER && document.documentElement.classList.add(`--${ BROWSER.toLowerCase() }`);

export const DOC_TITLE = 'Influmtr';

console.log(`OS: ${ OS }; BROWSER: ${ BROWSER }`);

export const CONTACT_EMAIL = 'hey@influmtr.com';

export const isFlexGapSupported = (() => {
  // create flex container with row-gap set
  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  const isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
})();
